import { Observable } from 'rxjs';

export abstract class ObservableLoader {
  constructor() {

  }

  public abstract load<T>(key: string, observable: () => Observable<T>): Observable<T>;
}
